import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Smartphone } from "lucide-react";
import ProfileLayout from "../components/ProfileLayout";
import EsimCard from "../components/EsimCard";
import { API } from "../auth/AuthContext";
import { pageItems } from "../lib/pageItems";

export default function ProfileEsims() {
  const [esims, setEsims] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/esim/mine`, { withCredentials: true });
      setEsims(pageItems(r.data));
    } catch (e) {
      // 401 handled by ProtectedRoute upstream
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <ProfileLayout eyebrow="Profile" title="My eSIMs">
      {loading && <div className="zc-card p-10 text-center text-[var(--zc-text-3)] text-sm">Loading…</div>}
      {!loading && esims.length === 0 && (
        <div className="zc-card p-10 text-center" data-testid="esim-empty">
          <div className="w-12 h-12 mx-auto grid place-items-center rounded-full" style={{ background: "var(--zc-secondary-soft)", color: "var(--zc-secondary)" }}>
            <Smartphone size={20} />
          </div>
          <h2 className="zc-headline text-2xl mt-5">No eSIMs yet.</h2>
          <p className="text-sm text-[var(--zc-text-2)] mt-2 max-w-sm mx-auto">
            Add the <b className="text-[var(--zc-text)]">Z-Cars Travel Pack</b> when you book a car —
            data, voice, and SMS in 170+ countries, valid for the length of your rental booking.
          </p>
          <Link to="/browse" className="inline-flex items-center px-5 h-11 zc-btn-primary text-sm mt-6">
            Browse the fleet
          </Link>
        </div>
      )}
      {!loading && esims.length > 0 && (
        <div className="space-y-5" data-testid="esim-list">
          {esims.map((e) => <EsimCard key={e.activation_id} esim={e} onUpdate={load} />)}
        </div>
      )}
    </ProfileLayout>
  );
}
